import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Container, Form, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import * as actions from '../actions/TrainingType';
import Breadcrumb from '../components/AdminBreadcrumb';

class TrainingType extends React.Component {
    
    handleSave = (e) => {
        const { name } = this.props.trainingType.toJS();
        if (name) {
            this.props.actions.updateTrainingType(this.props.trainingType);
            this.props.history.push('/TrainingTypes');
        }
    }

    updateTrainingTypeName = (e) => {
        const value = e.target.value;
        this.props.actions.updateTrainingTypeName(value)
    }

    updateTrainingTypeDescription = (e) => {
        const value = e.target.value;
        this.props.actions.updateTrainingTypeDescription(value)
    }

    render() {

        const { description, name, trainingTypeId } = this.props.trainingType.toJS();

        return (
            <Container>
                <div style={{ paddingBottom: '10px' }}>
                    <Breadcrumb history={this.props.history} />
                </div>
                <Form>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Name:</Label>
                                <Input type='text' invalid={!name} name='Name' onChange={this.updateTrainingTypeName} required value={name || ''} readonly={ !trainingTypeId } />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Description:</Label>
                                <Input type='text' name='Description' onChange={this.updateTrainingTypeDescription} value={description || ''} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button type="submit" className={'float-right'} disabled={!name} onClick={this.handleSave}>Save</Button>
                        </Col>
                    </Row>
                </Form >
            </Container>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        trainingType: state.TrainingType
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(TrainingType);